import axios from '@/plugins/axiosInstance'
import { googleIntegration } from '@/networking/urlManager'

/**
 * Selects a Google account for the integration
 * @param {string} assetId - The asset ID
 * @param {string} accountId - The account ID to select
 * @returns {Promise<Object>} API response
 */
export const selectAccount = async (assetId, accountId) => {
  try {
    const response = await axios.post(googleIntegration.accountsSelect, {
      assetId,
      accountId,
    })
    return response.data
  } catch (error) {
    throw error
  }
}
